import styled, { css } from 'styled-components';
import { SearchBar } from '../FAQSearchBar/FAQSearchBar.styles';

export const FAQTilesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 40px 44px;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.medium}) {
    gap: 24px;
  }
`;

export const FAQTile = styled.div`
  ${({ theme }) => css`
    display: flex;
    width: 345px;
    padding: 24px;
    border: 1px solid ${theme.colors.strokeSecondaryGrey10};
    border-radius: 12px;
    background: ${theme.colors.cardElevationMidWhite};
    box-shadow: ${theme.elevations.mid};

    @media screen and (${theme.breakpoints.small} < width < ${theme.breakpoints.medium}) {
      width: 224px;
    }

    @media screen and (max-width: ${theme.breakpoints.medium}) {
      padding: 16px;
      max-width: 292px;
    }

    cursor: pointer;
    &:hover,
    &:active,
    &:focus {
      p {
        color: ${theme.colors.textPrimarySecondary1100};
      }
    }
    &:hover,
    &:focus {
      background: ${theme.colors.cardInteractionHoverGrey05};
    }

    &:active {
      background: ${theme.colors.cardInteractionActiveSecondary420};
      box-shadow: ${theme.elevations.low};
    }
  `}
`;

export const FAQTileContent = styled.div`
  margin-left: 6px;
  display: flex;
  flex-direction: column;
`;

export const FAQPageWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.medium}) {
    ${SearchBar} {
      margin-bottom: 24px;
    }
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.small}) {
    ${SearchBar} {
      margin-bottom: 16px;
    }
  }
`;
